<template>
  <b-modal
    ref="caseTypesModal"
    size="xs"
    centered
    modal-class="caseTypes-modal"
    @hidden="hide"
  >
    <div slot="modal-title">
      {{ actionTitle }} <span style="text-transform: lowercase">{{ $tc('configuration.sections.caseTypes', 1) }}</span>
    </div>
    <b-row class="pt-2 pb-3 px-3">
      <b-col cols="12">
        <div class="form-label">
          <label>{{ $t('configuration.grid.name') }}</label>
        </div>
        <vt-input
          ref="code"
          v-model="internalCaseType.description"
          class="form-control-sm"
        />
      </b-col>
      <b-col
        cols="12"
        class="mt-3 d-flex justify-content-end"
      >
        <div class="switch-btn mt-1 p-0 d-flex align-items-center">
          <span
            v-if="internalCaseType.active"
            class="mr-2"
          >{{ $t('configuration.actions.active') }}</span>
          <span
            v-else
            class="mr-2"
          >{{ $t('configuration.actions.inactive') }}</span>
          <input
            id="toggle"
            v-model="internalCaseType.active"
            type="checkbox"
            class="offscreen"
            aria-hidden="true"
          >
          <label
            for="toggle"
            class="switch mb-0"
          />
        </div>
      </b-col>
    </b-row>
    <div
      slot="modal-footer"
      class="footer-banner px-2"
      style="width:100%;"
    >
      <div class="row">
        <div class="col-6 text-left">
          <b-button
            size="sm"
            variant="outline-secondary"
            data-dismiss="modal"
            @click="hide"
          >
            {{ $t('global.cancel') }}
          </b-button>
        </div>
        <div class="col-6 text-right">
          <b-button
            :disabled="!internalCaseType.description"
            size="sm"
            class="btn--primary"
            @click="update()"
          >
            <i
              class="fal fa-check mr-2"
              aria-hidden="true"
            />
            {{ actionTitle }}
          </b-button>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { cloneDeep, isEmpty } from 'lodash'

export default {
    name: 'CaseTypesModal',
    props: {
        actionTitle: String
    },
    data() {
        return {
            internalCaseType: {}
        }
    },
    methods: {
        async show(selectedCaseType) {
            if (selectedCaseType && !isEmpty(selectedCaseType)) {
                this.internalCaseType = cloneDeep(selectedCaseType)
            } else {
                this.clearData()
            }
            this.$refs.caseTypesModal.show()
            this.$nextTick(() => {
                this.$refs.code.focus()
            })
        },
        hide() {
            this.$refs.caseTypesModal.hide()
        },
        update() {
            if (this.internalCaseType.id) this.$emit('update', this.internalCaseType)
            else this.$emit('create', this.internalCaseType)
        },
        clearData() {
            this.internalCaseType = {
                active: true,
                description: ''
            }
        }
    }
}
</script>
